import { render, staticRenderFns } from "./SendViaPeppolModalWf.vue?vue&type=template&id=da997e92&scoped=true"
import script from "./SendViaPeppolModalWf.vue?vue&type=script&lang=ts"
export * from "./SendViaPeppolModalWf.vue?vue&type=script&lang=ts"
import style0 from "./SendViaPeppolModalWf.vue?vue&type=style&index=0&id=da997e92&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da997e92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da997e92')) {
      api.createRecord('da997e92', component.options)
    } else {
      api.reload('da997e92', component.options)
    }
    module.hot.accept("./SendViaPeppolModalWf.vue?vue&type=template&id=da997e92&scoped=true", function () {
      api.rerender('da997e92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SendViaPeppolModalWf.vue"
export default component.exports